import React from "react";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import { useConfig } from "../config/ConfigProvider";
import { IsMember, LockedListItem } from "../core/HasEntitlements";
import { ArrowListItem } from "../core/ArrowListItem";
import {
  getAttendedConventionForEvent,
  getPublishersLinkForAttendedConvention,
} from "../publishers/attended-convention-config";
import Button from "@mui/material/Button";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Link as RouterLink } from "react-router-dom";

const PublishersForConventionLocked = () => <LockedListItem title="View attending publishers" />;

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").AttendedConventions} props.attendedConvention
 */
const PublishersForConventionLink = ({ attendedConvention }) => (
  <ArrowListItem primary="View attending publishers" to={getPublishersLinkForAttendedConvention(attendedConvention)} />
);

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId} props.conventionId
 */
export const PublishersForConvention = ({ conventionId }) => {
  const { conventionCalendarEvents } = useConfig();
  const attendedConvention = getAttendedConventionForEvent(conventionCalendarEvents, conventionId);

  if (!attendedConvention) {
    return null;
  }

  return (
    <Card elevation={1} square={false}>
      <List>
        <IsMember LockedView={<PublishersForConventionLocked />}>
          <PublishersForConventionLink attendedConvention={attendedConvention} />
        </IsMember>
      </List>
    </Card>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId} props.conventionId
 */
export const PublishersForConventionPublic = ({ conventionId }) => {
  const { conventionCalendarEvents } = useConfig();
  const attendedConvention = getAttendedConventionForEvent(conventionCalendarEvents, conventionId);

  if (!attendedConvention) {
    return null;
  }

  return (
    <List>
      <PublishersForConventionLink attendedConvention={attendedConvention} />
    </List>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId} props.conventionId
 * @param {number} props.numberOfPublishersAttending
 */
export const PublishersForConventionButton = ({ conventionId, numberOfPublishersAttending }) => {
  const { conventionCalendarEvents } = useConfig();
  const attendedConvention = getAttendedConventionForEvent(conventionCalendarEvents, conventionId);

  if (!attendedConvention) {
    return null;
  }

  return (
    <Button
      component={RouterLink}
      to={getPublishersLinkForAttendedConvention(attendedConvention)}
      variant="contained"
      endIcon={<WorkspacePremiumIcon />}
    >
      View {numberOfPublishersAttending} attending publishers
    </Button>
  );
};
